import { IconButton, useTheme } from "@mui/material";
import { Plus, SlidersHorizontal } from "lucide-react";
import type { FC } from "react";

interface PortfolioHeaderActionsProps {
	hasPortfolioPilotRight: boolean;
	onSort: () => void;
	onAdd: () => void;
}

export const PortfolioHeaderActions: FC<PortfolioHeaderActionsProps> = ({
	hasPortfolioPilotRight,
	onSort,
	onAdd,
}) => {
	const theme = useTheme();

	return (
		<>
			<IconButton onClick={onSort}>
				<SlidersHorizontal color={theme.palette.primary.main} />
			</IconButton>
			{hasPortfolioPilotRight && (
				<IconButton onClick={onAdd}>
					<Plus color={theme.palette.primary.main} />
				</IconButton>
			)}
		</>
	);
};
